import { render } from "./Merchants.vue?vue&type=template&id=e1ca3206"
import script from "./Merchants.vue?vue&type=script&lang=js"
export * from "./Merchants.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/shop/Merchants.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e1ca3206"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e1ca3206', __exports__)) {
    api.reload('e1ca3206', __exports__)
  }
  
  module.hot.accept("./Merchants.vue?vue&type=template&id=e1ca3206", () => {
    api.rerender('e1ca3206', render)
  })

}


export default __exports__